import React from 'react';

export default () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.75 6.75C6.75 8.8175 8.4325 10.5 10.5 10.5C12.5675 10.5 14.25 8.8175 14.25 6.75C14.25 4.6825 12.5675 3 10.5 3C8.4325 3 6.75 4.6825 6.75 6.75ZM17.1667 18.8333H18V18C18 14.7842 15.3825 12.1667 12.1667 12.1667H8.83333C5.61667 12.1667 3 14.7842 3 18V18.8333H17.1667Z" fill="currentColor" />
  </svg>
);
